import { ensureRouteData } from '@/app/query-client'
import { dictionaryTermQueryOptions } from '@/features/courses/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import { parseSlug } from '@/screens/courses/lib/params'

/**
 * The `/learn/dictionary/$slug` loader.
 *
 * MAIN: the term. `null` (`DICTIONARY_TERM_NOT_FOUND`) is the screen's
 * not-found state. A `$slug` mm-be's slug converter would refuse is answered
 * without a request.
 */
export async function loadDictionaryTerm({
  context: { queryClient },
  params,
}: {
  context: RouterContext
  params: { slug: string }
}): Promise<void> {
  const slug = parseSlug(params.slug)
  if (slug === null) return
  await ensureRouteData(queryClient, dictionaryTermQueryOptions(slug))
}
